import * as React from 'react';

// ProductList ExtensionProperties keys. They must match SpringOrderPlanning in the CSU OrderTemplateOverrides project,
// which stores them for the F&O fields RetailProductListUpdate.GDNSpringOrder and GDNSpringOrderSubmitted.
export const SpringOrderProperty = 'GDNSpringOrder';
export const SpringOrderSubmittedProperty = 'GDNSpringOrderSubmitted';

export type SpringOrderField = typeof SpringOrderProperty | typeof SpringOrderSubmittedProperty;

export type ISpringOrderPlanningValues = Record<SpringOrderField, boolean>;

export interface IGdnSpringOrderPlanningProps {
    header?: string;
    springOrderLabel?: string;
    orderPlacedLabel?: string;
    values: ISpringOrderPlanningValues;
    disabled: boolean;
    errorMessage?: string;
    onFieldChange(field: SpringOrderField, value: boolean): void | Promise<void>;
}

export const GdnSpringOrderPlanning: React.FC<IGdnSpringOrderPlanningProps> = props => {
    const { header, springOrderLabel, orderPlacedLabel, values, disabled, errorMessage, onFieldChange } = props;

    // Same markup as the order template line selectors, so the theme's round .checkmark style applies.
    const renderField = (field: SpringOrderField, label?: string): JSX.Element => (
        <label className='checkbox-container spring-order-planning-checkbox'>
            <input
                aria-label={label}
                className='checkbox-input'
                type='checkbox'
                // eslint-disable-next-line security/detect-object-injection -- field is one of two constant keys
                checked={values[field]}
                // eslint-disable-next-line security/detect-object-injection -- field is one of two constant keys
                aria-checked={values[field]}
                disabled={disabled}
                onChange={event => onFieldChange(field, event.target.checked)}
            />
            <span className='checkmark' />
            {label}
        </label>
    );

    return (
        <section className='ms-order-template__spring-order-planning' aria-busy={disabled}>
            <h2>{header}</h2>
            {renderField(SpringOrderProperty, springOrderLabel)}
            {renderField(SpringOrderSubmittedProperty, orderPlacedLabel)}
            {errorMessage && (
                <p className='ms-order-template__spring-order-planning-error' role='alert'>
                    {errorMessage}
                </p>
            )}
        </section>
    );
};
